import { ILinks } from '@3.0/Layouts/TabbedLayout/utils/constants/routes.interface';
import { StudioRoutes } from 'Routing/RouteConstants';

export const dimissibleLinkMap: Record<string, ILinks> = {
  [StudioRoutes.ingestion.base]: {
    tabItem: {
      to: `/${StudioRoutes.base}/${StudioRoutes.ingestion.base}`,
      name: 'ingestion',
      label: 'Ingestion Logs',
      variant: 'primary',
      testId: 'ingestion-tab',
      isDismissible: true,
    },
    permissionRef: ['mappings', 'runIngestion', ['c', 'u', 'd']],
    featureFlag: true,
  },
};

export const dismissibleLinkPaths = [`/${StudioRoutes.base}/${StudioRoutes.ingestion.base}`];
